<template>
  <div id="page" class="page font--jakarta">
    <HeaderHilltopLayout />
    <slot />
    <FooterHilltopLayout2 />
  </div>
</template>

<style src="~/assets/css/color-scheme/hilltop.scss" lang="scss"></style>
